import { render, staticRenderFns } from "./gift-card.vue?vue&type=template&id=725b2ca0&scoped=true"
import script from "./gift-card.vue?vue&type=script&lang=js"
export * from "./gift-card.vue?vue&type=script&lang=js"
import style0 from "./gift-card.vue?vue&type=style&index=0&id=725b2ca0&prod&lang=less"
import style1 from "./gift-card.vue?vue&type=style&index=1&id=725b2ca0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725b2ca0",
  null
  
)

export default component.exports